module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_datalake-d81b0f77074936abc707c2640f8e6583.png";